import { createAction, props } from "@ngrx/store";
import { ICreateInstallationRequest, IGetInstallationDetailResponse, IGetInstallationResponse, IGetInstallationsByCompanyRequest, IUpdateInstallationRequest } from "src/app/installations/models/installation";

// Get Installations 
export const getInstallations = createAction(
    '[Installations] Get Installations '
);

export const getInstallationsSuccess = createAction(
    '[Installations] Get Installations success', 
    props<{ installations: IGetInstallationResponse[] }>()
);

export const getInstallationsFailure = createAction(
    '[Installations] Get Installations failure',
    props<{error: string}>()
);

// Get Installation by id
export const getInstallationById = createAction(
    '[Installations] Get Installation by id ',
    props<{id: string}>()
);

export const getInstallationByIdSuccess = createAction(
    '[Installations] Get Installation by id success', 
    props<{ installation: IGetInstallationDetailResponse }>()
);

export const getInstallationByIdFailure = createAction(
    '[Installations] Get Installation by id failure',
    props<{error: string}>()
);

// Get Installations by company
export const getInstallationsByCompany = createAction(
    '[Installations] Get Installations by company ',
    props<{request: IGetInstallationsByCompanyRequest}>()
);

export const getInstallationsByCompanySuccess = createAction(
    '[Installations] Get Installation by company success', 
    props<{ installations: IGetInstallationResponse[] }>()
);

export const getInstallationsByCompanyFailure = createAction(
    '[Installations] Get Installations by company failure',
    props<{error: string}>()
);

// Create Installation
export const createInstallation = createAction(
    '[Installations] Create Installation',
    props<{ installation: ICreateInstallationRequest }>()
);

export const createInstallationSuccess = createAction(
    '[Installations] Create Installation success',
    props<{ installation: IGetInstallationResponse }>()
);

export const createInstallationFailure = createAction(
    '[Installations] Create Installation failure',
    props<{error: string}>()
);

// Update Installation 
export const updateInstallation = createAction(
    '[Installations] Update Installation',
    props<{ installation: IUpdateInstallationRequest }>()
);

export const updateInstallationSuccess = createAction(
    '[Installations] Update Installation success',
    props<{ installation: IGetInstallationResponse }>()
);

export const updateInstallationFailure = createAction(
    '[Installations] Update Installation failure',
    props<{error: string}>()
);

// Delete Installation
export const deleteInstallation = createAction(
    '[Installation] Delete Installation',
    props<{id: string}>()
);

export const deleteInstallationSuccess = createAction(
    '[Installation] Delete Installation success',
    props<{id: string}>()
);

export const deleteInstallationFailure = createAction(
    '[Installation] Delete Installation failure',
    props<{error: string}>()
);